import { ChildrenList } from './OutlineNode';
import PreviewNavList from './PreviewNavList';

// Same hand-built-SVG convention as TopicIcon (OutlineNode.jsx) - two
// stacked chevrons is the near-universal "expand/collapse everything" glyph.
function ExpandAllIcon() {
   return (
      <svg viewBox='0 0 24 24' width='13' height='13' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
         <polyline points='6,6 12,11 18,6' />
         <polyline points='6,14 12,19 18,14' />
      </svg>
   );
}
function CollapseAllIcon() {
   return (
      <svg viewBox='0 0 24 24' width='13' height='13' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
         <polyline points='6,19 12,14 18,19' />
         <polyline points='6,11 12,6 18,11' />
      </svg>
   );
}

// The course itself is the tree's implicit root - ChildrenList already
// knows how to render "everything under one parent" (its own directly-
// attached Topics + its structural children) for any hostable level, so
// pointing it at 'course' here gets the course's own topics section and
// its Modules list "for free" through the exact same component every
// other level uses, instead of needing a bespoke course-level section.
//
// `preview` used to render the exact same nested/expandable tree read-only,
// just restyled - but a real table-of-contents shouldn't ask the reader to
// expand/collapse anything: it flattens to PreviewNavList (one flat list of
// Topics, structural Module/Chapter/Unit/Lesson levels reduced to plain
// gray section markers, per explicit user request) instead of ChildrenList.
// The expand/collapse-all toolbar is meaningless once there's nothing to
// expand, so it's Constructor-only now. Unlike the Constructor tree, the
// Preview nav also gets a real "whole course" click target (PreviewNavList's
// own course row) - `preview` mode is the only place selecting the Course
// root itself is meaningful (it flattens every topic in the course into one
// scroll), so `courseName`/`activeTopicId` only ever matter in this branch.
export default function OutlineTree({ courseId, courseName, actions, preview, activeTopicId }) {
   return (
      <div className={'course-tree' + (preview ? ' course-tree-preview' : '')}>
         {preview ? '' : (
            <div className='course-tree-toolbar'>
               <div className='course-tree-toolbar-btn' onClick={actions.expandAll} title='Розгорнути все'>
                  <ExpandAllIcon />
               </div>
               <div className='course-tree-toolbar-btn' onClick={actions.collapseAll} title='Згорнути все'>
                  <CollapseAllIcon />
               </div>
            </div>
         )}
         {preview ? (
            <PreviewNavList courseId={courseId} courseName={courseName} actions={actions} activeTopicId={activeTopicId} />
         ) : (
            <ChildrenList levelKey='course' parentId={courseId} actions={actions} />
         )}
      </div>
   );
}
